import * as styles from "./AlertDialogHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { AlertDialogHeaderProps } from "./AlertDialog.types";

export function AlertDialogHeader({
  className,
  ...props
}: AlertDialogHeaderProps): JSX.Element {
  return (
    <div
      data-slot="alert-dialog-header"
      className={clsx(styles.header, className)}
      {...props}
    />
  );
}
